module.exports = __webpack_public_path__ + "static/media/abe-money.a79621c8.png";